import packageApp from '~/packages_and_registries/package_registry/index';

packageApp();
